"use client";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { Paper as p, Link as u, Heading as f, Group as h, Paragraph as g, AnimatedButton as x, sharedHandler as y } from "@ingeniorforeningen/figurine-core";
import { forwardRef as _ } from "react";
import '../../../assets/BenefitCard.css';const B = "_root_17cnn_2", C = "_button_17cnn_14", r = {
  root: B,
  button: C
}, a = _((o, i) => {
  const { header: d, text: s, cta: e, fluid: l, mod: m, ...c } = o;
  return /* @__PURE__ */ t(
    p,
    {
      className: ` ${r.root}`,
      ...c,
      ref: i,
      p: 0,
      mod: { fluid: l, ...m },
      variant: "secondary",
      children: /* @__PURE__ */ n(u, { p: 0, href: e.href, target: e.target, children: [
        /* @__PURE__ */ t(
          f,
          {
            type: "h3",
            text: d,
            className: "",
            variant: "light",
            mx: "lg",
            pt: "xl",
            lineClamp: 2
          }
        ),
        /* @__PURE__ */ n(h, { direction: "column", mx: "lg", py: "md", children: [
          /* @__PURE__ */ t(g, { lineClamp: 6, text: s, variant: "light", condensed: !0 }),
          /* @__PURE__ */ t(
            x,
            {
              link: { ...e, text: void 0 },
              variant: "light",
              useParentLink: !0,
              className: r.button
            }
          )
        ] })
      ] })
    }
  );
});
a.displayName = "BenefitCard";
const N = y(a);
N.displayName = a.displayName;
export {
  r as B,
  a as _BenefitCard,
  N as default
};
